import { useUserOrganization } from '@modules-deprecated/app/organization'
import { UiSetup } from '@modules-deprecated/app/organization/enums/uiSetup'

export const useOrganizationUiSetup = () => {
  const { organization } = useUserOrganization()

  const isUiSetupAccounting = organization?.uiSetup === UiSetup.Accounting
  const isUiSetupShineInvoicingAccounting = organization?.uiSetup === UiSetup.ShineInvoicingAccounting
  const isUiSetupSupernavInvoicingAccounting = organization?.uiSetup === UiSetup.SupernavInvoicingAccounting

  return { isUiSetupAccounting, isUiSetupShineInvoicingAccounting, isUiSetupSupernavInvoicingAccounting }
}
